import { CSSProperties } from 'react';
import { Size } from '@vivli/shared/theme';
import { CheckboxFormFieldComponent, FieldHeaderComponent } from '@vivli/shared/components';
import { DataRequestHintsConstant, DTIAttestationsForm } from '@vivli/shared/infrastructure/constants';

const containerStyle: CSSProperties = {
    paddingLeft: Size.INSET_SIZE,
    paddingRight: Size.INSET_SIZE,
    paddingBottom: Size.INSET_SIZE,
    display: 'grid',
    gridAutoRows: 'auto',
    rowGap: '20px',
};

const checkboxFieldStyle: CSSProperties = {};

export const AttestationsFormComponent = () => {
    return (
        <div style={containerStyle}>
            <FieldHeaderComponent title="Certify Complete and Accurate" />
            {DataRequestHintsConstant.requirementsAndAttestations.hasCertifiedCompleteAndAccurate}

            <CheckboxFormFieldComponent
                name={'requirementsAndAttestations.hasCertifiedCompleteAndAccurate'}
                label={`I certify the information provided is complete and accurate.`}
                truncateLabel={false}
                reverseOrientation={true}
                style={checkboxFieldStyle}
                dataId={DTIAttestationsForm.AttestationCheckBox}
                errorPlacement={'top-start'}
            />

            <FieldHeaderComponent title="Data Use Agreement" />

            <div>
                Please note that all Data Requestors wishing to receive access to data must execute the Data Use Agreement (DUA) before the
                data can be provided. The DUA is the product of extensive negotiation with the organizations that contribute data to Vivli,
                and as such, the agreement is non-negotiable. The DUA form must be completed and signed and is available{' '}
                {
                    <a target="_blank" href="https://vivli.org/resources/Vivli-Data-Use-Agreement/">
                        here
                    </a>
                }
                .
            </div>
            <div>
                You can either fill out the DUA form and sign it digitally, or print it out, sign it and scan it as PDF. Once the DUA has
                been signed by your organization, please upload it using the Signed Agreements tab of this data request (visible once the
                data request is submitted).
            </div>
            <div>
                If you have any questions regarding the DUA, please contact a Vivli admin at{' '}
                <a href="mailto:support@vivli.org">support@vivli.org</a>.
            </div>
        </div>
    );
};
